import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

import { AuthGuard } from './auth/auth.guard';
import { NgModule } from '@angular/core';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { PackageCenterComponent } from './package-center/package-center.component';
import { MatAccountComponent } from './mat-account/mat-account.component';
import { AccountAdminCenterComponent } from './account-admin-center/account-admin-center.component';
import { DataManagementComponent } from './data-management/data-management.component';
import { PackageDetailsComponent } from './mat-admin/package-details/package-details.component';
import { AdminDetailsComponent } from './user-center/admin-details/admin-details.component';
import { NotificationsComponent } from './user-center/notifications/notifications.component';
import { DataAlertsComponent } from './user-center/notifications/data-alerts/data-alerts.component';
import { AddSchoolComponent } from './user-center/add-school/add-school.component';
import { CreateUserComponent } from './user-center/create-user/create-user.component';
import { UserDetailsComponent } from './user-center/create-user/user-details/user-details.component';
import { SchoolDetailsComponent } from './school/school-details/school-details.component';
import { SchoolBasicDetailsComponent } from './school/school-basic-details/school-basic-details.component';
import { UserRoleComponent } from './user-center/user-role/user-role.component';
import { ProfileComponent } from './profile/profile.component';
import { IndependentSchoolComponent } from './independent-school/independent-school.component';
import { CreateRoleComponent } from './user-center/create-role/create-role.component';
import { SchoolListComponent } from './school/school-list/school-list.component';
import { SectorComponent } from './sector/sector.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EditAccountDetailsComponent } from './user-center/edit-account-details/edit-account-details.component';
import { TicketManagementComponent } from './ticket-management/ticket-management.component';
import { ViewTicketCommentsComponent } from './ticket-management/view-ticket-comments/view-ticket-comments.component';
import { AddTicketCommentsComponent } from './ticket-management/add-ticket-comments/add-ticket-comments.component';
import { TransferSchoolComponent } from './user-center/transfer-school/transfer-school.component';
import { RequestAccessComponent } from './school/request-access/request-access.component';
import { ErrorLogComponent } from './error-log/error-log.component';
import { TraceReportComponent } from './trace-report/trace-report.component';
import { SystemMessagesComponent } from './system-messages/system-messages.component';
import { StudentComponent } from './education/student/student.component';
import { OnepageComponent } from './onepage/onepage.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'forgetPassword', component: ForgotPasswordComponent },
  { path: 'matAccount', component: MatAccountComponent },
  { path: 'addSchool', component: AddSchoolComponent },
  { path: 'createUser', component: CreateUserComponent },
  { path: 'schoolDetails', component: SchoolDetailsComponent },
  { path: 'editaccountDetails', component: EditAccountDetailsComponent },
  {
    path:'education',
    component: OnepageComponent,
    canActivate: [AuthGuard],
    children:[
      { path: 'student/:singleparam', component:StudentComponent, title:'Student'}
    ]
  },
  {
    path: '',
    component: SidemenuComponent,
    children: [
      {
        path:'education', 
        outlet:'popup',
        component: OnepageComponent,
        //data: { isPopup: true },
        children:[
          { path: 'student/:singleparam', component:StudentComponent, title:'Student'}
      ]},
      { path: 'accountAdminCenter', component: AccountAdminCenterComponent },
      { path: 'packageCenter', component: PackageCenterComponent },
      { path: 'userCenter', component: MatAccountComponent },
      { path: 'independentSchool',component: IndependentSchoolComponent},
      { path: 'dataManagement', component: DataManagementComponent },
      { path: 'adminDetails', component: AdminDetailsComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'packageDetails', component: PackageDetailsComponent },
      { path: 'userRole', component: UserRoleComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'createRole', component: CreateRoleComponent },
      { path: 'userDetails', component: UserDetailsComponent },
      { path: 'schoolBasicDetails', component: SchoolBasicDetailsComponent },
      { path: 'schoolList', component: SchoolListComponent },
      { path: 'sector', component: SectorComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'ticketManagement', component: TicketManagementComponent },
      { path: 'viewTicketsComments', component: ViewTicketCommentsComponent },
      { path: 'addTicketsComments', component: AddTicketCommentsComponent },
      { path: 'transferSchool', component:TransferSchoolComponent},
      { path: 'requestAccess', component:RequestAccessComponent},
      { path: 'errorLog', component: ErrorLogComponent },
      { path: 'traceReport', component: TraceReportComponent },
      { path:'systemMessages', component: SystemMessagesComponent}
    ],
    canActivate: [AuthGuard],
  },

  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
